module.exports = __webpack_public_path__ + "img/Unidad19-4.9b1665dd.png";